import React from "react";
import { Box, TextField, InputAdornment, Chip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const QUICK_TAGS = ["NET", "OS", "SPQ", "AI", "DB", "ENG"];

export default function FeedSearchBar({ value, onChange, onTag }) {
  return (
    <Box sx={{ px: 1.5, pt: 1.5, pb: 1 }}>
      <TextField
        fullWidth
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search people or tags (e.g., @ken, NET, #OS)"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "999px",
            bgcolor: "background.paper",
          },
        }}
      />

      <Box sx={{ display: "flex", gap: 1, mt: 1, overflowX: "auto" }}>
        {QUICK_TAGS.map((t) => (
          <Chip
            key={t}
            label={t}
            clickable
            onClick={() => onTag(t)}
            sx={{ flex: "0 0 auto" }}
          />
        ))}
      </Box>
    </Box>
  );
}
